export const login = {
  titleBox: {
    title1: "Share new perspectives",
    title2: "Assist in a better life",
    title3: "SMS login",
    title4: "Account password",
    title5: "Mobile phone number",
    title6: "Verification code",
    title7: "Please enter your phone number",
    title8: "Please enter the verification code",
    title9: "Forgot password?",
    title10: "Login",
    title11: "By logging in, it means you have read and agreed to it",
    title12: "Privacy Policy",
    title13: "Service Agreement",
    title14: "Register Now",
    title15: "Third party login",
    title16: "Password",
    title17: "Please enter password",
    title18: "Existing account",
    title19: "Account registration",
    title20: "Registering means that you have read and agreed to it",
    title21: "Register",
    title22: "Forgot password",
    title23: "Next step",
    title24: "Set password",
    title25: "Confirm password",
    title26: "Complete",
    title27: "Return to login",
    title28: "SMS verification code",
    title29: "s to get",
    title30: "Get code",
    title31: "New password",
    title32: "Previous step",
    title33: "Please enter your phone number first",
    title34: "Modified successfully",
  },
};
